import request from "@/utils/request.js";


export function checkShareLinkAuth(params) {
  return request({
    url: "/operateService/api/app/course/sharing/experience/checkShareLinkAuth",
    method: "post",
    data: params
  });
}

export function shareLink(params) {
  return request({
    url: "/operateService/api/app/course/sharing/experience/shareLink",
    method: "post",
    data: params
  });
}


